<template>
  <div>
    <div class="page-title">
      <h3>{{'New_Rec' | localize }}</h3>
    </div>

    <Loader v-if="loading" />

    <p class="center" v-else-if="!categories.length">Категорий нет. <router-link to="/categories">Добавить категорию</router-link></p>

    <form class="form" @submit.prevent="submitHandler" v-else >
      <div class="input-field" >
        <select ref="select" v-model="category">
          <option
            v-for="c in categories"
            :key="c.id"
            :value="c.id"
          >
          {{c.title}}
          </option>
        </select>
        <label>{{'Choose_Cat' | localize }}</label>
      </div>

      <p>
        <label>
          <input
              class="with-gap"
              name="type"
              type="radio"
              value="income"
              v-model="type"
          />
          <span>{{'InCome' | localize }}</span>
        </label>
      </p>

      <p>
        <label>
          <input
              class="with-gap"
              name="type"
              type="radio"
              value="outcome"
              v-model="type"
          />
          <span>{{'OutCome' | localize }}</span>
        </label>
      </p>

      <div class="input-field">
        <input
            id="amount"
            type="number"
            v-model.number="amount"
            :class="{invalid: $v.amount.$dirty && !$v.amount.minValue}"
        >
        <label for="amount">{{'Amount' | localize }}</label>
        <span
                        v-if="$v.amount.$dirty && !$v.amount.minValue"
                        class="helper-text invalid"
                >
                {{'Min_Value_Limit' | localize }} {{$v.amount.$params.minValue.min}}
                </span>
      </div>

      <div class="input-field">
        <input
            id="description"
            type="text"
            v-model="description"
            :class="{invalid: $v.description.$dirty && !$v.description.required}"
        >
        <label for="description">{{'Desc' | localize }}</label>
        <span
            v-if="$v.description.$dirty && !$v.description.required"
            class="helper-text invalid"
                >
                  {{'Enter_Desc' | localize }} 
        </span>
      </div>

      <button class="btn waves-effect waves-light" type="submit">
        {{'Create_Rec' | localize }}
        <i class="material-icons right">send</i>
      </button>
    </form>
  </div>
</template>
<script>
  import {required, minValue} from 'vuelidate/lib/validators'
  import {mapGetters} from 'vuex'
  //import localizeFilter from '@/filters/localize.filter'
  export default{
    metaInfo() {
    return {
      title: this.$title('New_Rec')
    } 
  },
    name: 'record',
    data: () => ({
      categories: [],
      loading: true,
      select: null,
      category: null,
      type: 'outcome',
      amount: 1,
      description: ''
    }),
    validations: {
      amount: {minValue: minValue(1)},
      description: {required}
    },
    async mounted(){
      this.categories = await this.$store.dispatch('fetchCategories')
      this.loading = false
      if(this.categories.length){
        this.category = this.categories[0].id
      }
      setTimeout( () => {
        this.select = window.M.FormSelect.init(this.$refs.select)
        window.M.updateTextFields()
      },0)
      
      
    },
    destroyed() {
      if (this.select && this.select.destroy) {
        this.select.destroy()
      }
      },
    computed:{
        ...mapGetters(['info']),
        canCreateRecord() {
        if(this.type === 'income'){
          return true
        }
        return this.info.bill >= this.amount
      },
        //messageIn: localizeFilter('InCome'),
        //messageOut: localizeFilter('OutCome')
      },
    methods: {
      async submitHandler() {
        if (this.$v.$invalid) {
          this.$v.$touch()
          return
        }  
        if(this.canCreateRecord){
          try {
            await this.$store.dispatch('createRecord', {
            categoryId: this.category,
            amount: this.amount,
            type: this.type,
            description: this.description,
            date: new Date().toJSON()
          })
          const bill = this.type === 'income'
            ? this.info.bill + this.amount
            : this.info.bill - this.amount

            await this.$store.dispatch('updateInfo',{bill})
            this.$message('Запись успешно создана')
            this.$v.$reset()
            this.amount = 1
            this.description = ''
          } 
          catch (error) {
            throw error
          }  
        }
        else {
          this.$message(`Недостаточно средств (${this.amount - this.info.bill}) `)
        }
    }
  }
}   
</script>